import { unitMapping } from '#src/lib/style.ts';

type Props = { size?: keyof typeof unitMapping };
export const Gavel = ({ size = 2 }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.432 18.4035L18.8973 16.9382L22.5347 13.3009L23.9999 11.8356L20.9771 8.81268C20.1678 9.62193 18.8557 9.62193 18.0465 8.81268L15.1918 5.95803C14.3826 5.14878 14.3826 3.83674 15.1918 3.02749L12.1644 0L5.59645 6.56794L8.62392 9.59541C9.43321 8.78613 10.7555 8.79637 11.5648 9.60565L1.6064 19.5641L4.43597 22.3937L14.3944 12.4352C15.2037 13.2445 15.2184 14.5713 14.4091 15.3806L17.432 18.4035Z"
        fill="#927AFF"
      />
    </svg>
  );
};
